import { Tolgee, DevTools, VueTolgee, FormatSimple, BackendFetch } from '@tolgee/vue'

export default defineNuxtPlugin(async (nuxtApp) => {
  const enData = await import('@/locales/en.json')
  const deData = await import('@/locales/de.json')

  const runtimeConfig = useRuntimeConfig()
  const i18n = nuxtApp.$i18n as { locale?: { value?: string } } | undefined
  const currentLanguage = i18n?.locale?.value || 'en'

  const apiKey = runtimeConfig.public.tolgeeApiKey as string | undefined
  const projectId = runtimeConfig.public.tolgeeProjectId as string | undefined

  const initConfig: {
    language: string
    apiUrl: string
    apiKey?: string
    projectId?: number
    staticData: {
      en: typeof enData.default
      de: typeof deData.default
    }
  } = {
    language: currentLanguage,
    apiUrl: 'https://tolgee.thrivestate.app',
    apiKey: apiKey,
    staticData: {
      en: enData.default,
      de: deData.default,
    },
  }

  if (projectId) {
    initConfig.projectId = Number(projectId)
  }

  const tolgee = Tolgee()
    .use(DevTools())
    .use(FormatSimple())
    .use(
      BackendFetch({
        prefix: 'https://thrivestate-tolgee-cdn-bucket.s3.eu-central-1.amazonaws.com/728cf681c6ffea2d37fe6bf0408cf2c2',
      })
    )
    .init(initConfig)

  await tolgee.run()

  nuxtApp.vueApp.use(VueTolgee, {
    tolgee,
  })
})
